<script setup lang="ts">
import { QuestionIcon } from '~/assets/data/icons';

interface IIconProps {
  dimensions?: number;
  customFill?: string;
}
const props = withDefaults(defineProps<IIconProps>(), {
  dimensions: 18,
  customFill: null,
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="`0 0 ${dimensions} ${dimensions}`"
    :height="dimensions"
    :width="dimensions"
  >
    <path
      :d="QuestionIcon"
      :class="
        customFill ??
        'fill-[url(#dark-gradient)] dark:fill-[url(#light-gradient)]'
      "
    />
  </svg>
</template>
